import ReactDOM from 'react-dom/client';
import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import i18n from './i18n';
import { AuthGate } from './auth/AuthGate';
import { createMsalConfig, loadAuthRuntimeConfig } from './auth/msalConfig';
import { loadLcaServerUrl } from './config/serverConfig';

const App = React.lazy(() => import('./App'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

Promise.all([loadAuthRuntimeConfig(), loadLcaServerUrl()]).then(([authConfig, lcaServerUrl]) => {
  const msalInstance = new PublicClientApplication(createMsalConfig(authConfig));

  msalInstance.initialize().then(() => root.render(
    <Suspense fallback={<div>Loading</div>}>
      <I18nextProvider i18n={i18n}>
        <MsalProvider instance={msalInstance}>
          <AuthGate authConfig={authConfig}>
            <App lcaServerUrl={lcaServerUrl} />
          </AuthGate>
        </MsalProvider>
      </I18nextProvider>
    </Suspense>,
  ));
}).catch((error) => {
  root.render(<div>{error instanceof Error ? error.message : 'Could not load auth configuration.'}</div>);
});
